import { useEffect } from "react";

export const ReloadOnBackButton = () => {
    useEffect(() => {
        // Get all navigation entries from the Performance API
        const navigationEntries = window.performance.getEntriesByType('navigation');

        // Check if the most recent navigation type is 'back_forward'
        // This indicates the user used the browser's back/forward buttons
        if (navigationEntries.length > 0 && (navigationEntries[0] as PerformanceNavigationTiming).type === 'back_forward') {

            // Retrieve the 'hasReloaded' flag from session storage
            const hasReloaded = sessionStorage.getItem('hasReloaded');

            // If the page has not been reloaded yet, proceed to reload
            if (!hasReloaded) {
                // Set the 'hasReloaded' flag to avoid reload loops
                sessionStorage.setItem('hasReloaded', 'true');

                // Reload the page to ensure a fresh state from the server
                window.location.reload();
            }
        } else {
            // Clear the 'hasReloaded' flag on fresh navigations
            // This ensures future back/forward navigation can trigger a reload again
            sessionStorage.removeItem('hasReloaded');
        }
    }, []); // Empty dependency array to ensure this effect runs only on mount

    return null;
};
